const nav = require('./nav.json');
const common = require('./common.json');
const form = require('./form.json');
const validation = require('./validation.json');
const auth = require('./auth.json');
const table = require('./table.json');
const reports = require('./reports.json');
const pageIntro = require('./pageIntro.json');
const help = require('./help.json');
const dashboard = require('./dashboard.json');
const workers = require('./management/workers.json');
const activities = require('./management/activities.json');
const crops = require('./management/crops.json');
const groups = require('./management/groups.json');
const users = require('./management/users.json');
const devices = require('./management/devices.json');
const stickers = require('./management/stickers.json');
const workdays = require('./management/workdays.json');
const dataEdit = require('./management/dataEdit.json');
const blocks = require('./management/blocks.json');
const settings = require('./management/settings.json');
const exportResource = require('./management/export.json');

module.exports = {
  nav,
  common,
  form,
  validation,
  auth,
  table,
  reports,
  pageIntro,
  help,
  dashboard,
  workers,
  activities,
  crops,
  groups,
  users,
  devices,
  stickers,
  workdays,
  dataEdit,
  blocks,
  settings,
  export: exportResource
};
